module.exports = __webpack_public_path__ + "media/images/payments/paysafecard-585bd4f8c33d33e037299bbd9ec377e7.svg";